import React from "react";
import { Box, Typography } from "@mui/material";

// Icons (replace with SVG if you want exact match)
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";

const policies = [
  {
    title: "Privacy Policy",
    icon: <SecurityOutlinedIcon sx={{ fontSize: { xs: 36, sm: 48, md: 70 } }} />,
    active: true,
  },
  {
    title: "Risk Disclosure",
    icon: <WarningAmberOutlinedIcon sx={{ fontSize: { xs: 36, sm: 48, md: 70 } }} />,
  },
  {
    title: "AML & CTF Policy",
    icon: <FingerprintIcon sx={{ fontSize: { xs: 36, sm: 48, md: 70 } }} />,
  },
  {
    title: "Complaints Handling",
    icon: <BalanceOutlinedIcon sx={{ fontSize: { xs: 36, sm: 48, md: 70 } }} />,
  },
];

const ServicesHero = ({
  heading,
  highlightedText,
  description,
  subDescription,
  image,
  activeTab,
  onTabChange,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        bgcolor: "var(--color-bg)",
        pb: onTabChange ? { xs: 8, md: 14 } : 0,
      }}
    >
      {/* TEXT SECTION */}
      <Box sx={{ width: "100%", maxWidth: "100%", mx: "auto" }}>
        <Box sx={{ py: { xs: 3, md: 3 }, textAlign: "center", position: "relative", overflow: "hidden" }}>
          <Typography
            variant="h1"
            className="svc-hero-anim-heading"
            sx={{
              fontWeight: 700,
              lineHeight: 1.3,
              fontSize: { xs: "2.2rem", sm: "3rem", md: "4rem" },
              maxWidth: "900px",
              mx: "auto",
              mb: 1,
              color: "#fff",
              position: "relative",
              zIndex: 1,
            }}
          >
            {heading}{" "}
            <Box component="span" sx={{ color: "#C44D3D" }}>
              {highlightedText}
            </Box>
          </Typography>

          <Typography
            className="svc-hero-anim-desc"
            sx={{
              color: "rgba(255,255,255,0.7)",
              maxWidth: "850px",
              mx: "auto",
              lineHeight: 1.8,
              mb: 2,
            }}
          >
            {description}
          </Typography>

          <Typography
            className="svc-hero-anim-desc"
            sx={{
              color: "rgba(255,255,255,0.7)",
              maxWidth: "750px",
              mx: "auto",
              lineHeight: 1.8,
            }}
          >
            {subDescription}
          </Typography>
        </Box>
      </Box>

      {/* IMAGE + NAV WRAPPER */}
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Box sx={{ position: "relative", width: "100%", maxWidth: "100%" }}>
          {/* IMAGE - FIXED */}
          <Box
            component="img"
            src={image}
            alt="hero"
            className="svc-hero-anim-image"
            sx={{
              width: "100%",
              height: { xs: 'auto', md: 'auto' }, // Auto height on mobile
              objectFit: "contain", // Changed from 'cover' to 'contain'
              display: "block",
            }}
          />

          {/* NAV CARDS — only on Privacy Policy page */}
          {onTabChange && (
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                bottom: { xs: "-60px", md: "-80px" },
                transform: "translateX(-50%)",
                width: { xs: "95%", md: "88%" },
                bgcolor: "rgba(23,24,29,0.92)",
                backdropFilter: "blur(12px)",
                borderRadius: "18px",
                border: "1px solid rgba(255,255,255,0.10)",
                overflow: "hidden",
                display: "grid",
                gridTemplateColumns: "repeat(4,1fr)",
                boxShadow: "0 25px 60px rgba(0,0,0,0.6)",
                zIndex: 10,
              }}
            >
              {policies.map((item, index) => {
                const isActive = activeTab !== undefined ? activeTab === index : item.active;
                return (
                  <Box
                    key={item.title}
                    onClick={() => onTabChange && onTabChange(index)}
                    sx={{
                      position: "relative",
                      minHeight: { xs: 100, sm: 130, md: 180 },
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: { xs: 1, md: 1.5 },
                      px: { xs: 1, sm: 2, md: 3 },
                      py: { xs: 2, md: 4 },
                      cursor: "pointer",

                      borderRight:
                        index !== policies.length - 1
                          ? "1px solid rgba(255,255,255,0.08)"
                          : "none",

                      borderBottom: "none",

                      transition: "0.3s",
                      bgcolor: isActive ? "rgba(255,255,255,0.04)" : "transparent",

                      "&:hover": {
                        bgcolor: "rgba(255,255,255,0.06)",
                      },

                      "&::after": isActive
                        ? {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          bottom: 0,
                          width: "100%",
                          height: "4px",
                          background: "linear-gradient(90deg,#7AD4C5,#8BF0DE)",
                        }
                        : {},
                    }}
                  >
                    {/* ICON */}
                    <Box sx={{ color: "#fff", opacity: 0.9 }}>
                      {item.icon}
                    </Box>

                    {/* TITLE */}
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: { xs: "11px", sm: "13px", md: "16px" },
                        fontWeight: 500,
                        textAlign: "center",
                        lineHeight: 1.3,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ServicesHero;